export default __webpack_public_path__ + "static/media/1314 knife block A side.b9ce12b5.png";